<div class="container-fluid font-white d-flex flex-column flex-md-row">
  <!-- Sidebar Tabs -->
  <div class="p-4">
    <aside class="stepper position-relative d-flex align-items-start flex-column">
      <div class="fs-16 fw-bold font-white">Settings</div>
      <div class="fs-14 fw-normal font-white mb-3">Choose an action</div>
      <div class="d-flex flex-column gap-2">
        <div *ngFor="let tab of tabList" class="step d-flex align-items-center gap-2 plans-tab p-2 border-radius-10"
          [ngClass]="{ 'bg-selected': selectedTab === tab.key }" (click)="changeTab(tab.key)"
          (keydown.enter)="changeTab(tab.key)" (keydown.space)="changeTab(tab.key)" tabindex="0" role="button">
          <div [innerHtml]="tab.icon(24, 24) | sanitizer : 'html'"></div>
          <div class="label font-white">{{ tab.label }}</div>
        </div>
      </div>
    </aside>
  </div>

  <!-- Vertical Divider -->
  <div class="d-flex align-items-center" style="height: 100vh">
    <div class="vr"></div>
  </div>

  <!-- Content Area -->
  <div class="flex-grow-1 font-white">
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between ms-4">
      <div class="d-flex">
        <div [innerHtml]="SVG_ICONS.MEMBERSHIP_PLANS_ICON(44, 44) | sanitizer : 'html'"></div>
        <div class="ms-2 mt-1">
          <div>{{ getSelectedTabLabel() }}</div>
          <p class="fs-14 fw-normal font-white">Create or edit {{ getSelectedTabLabel() }}.</p>
        </div>
      </div>
      <div>
        <ng-container [ngSwitch]="selectedTab">
          <button *ngSwitchCase="'package'" class="btn btn-success border-radius-10" (click)="onCreatePlan()">Create New
            Plan</button>
          <button *ngSwitchCase="'menu'" class="btn btn-success border-radius-10" (click)="onCreateMenu()">Create New
            Menu</button>
          <button *ngSwitchCase="'region'" class="btn btn-success border-radius-10" (click)="onCreateRegion()">Create
            New Region</button>
          <!-- <button *ngSwitchCase="'city'" class="btn btn-success border-radius-10" (click)="onCreateCity()">Create New City</button> -->
          <button *ngSwitchCase="'area'" class="btn btn-success border-radius-10" (click)="onCreateArea()">Create New
            Area</button>
          <!-- <button *ngSwitchCase="'user-access'" class="btn btn-success border-radius-10" (click)="onUserTypePermissionCreate()">Create New User Type</button> -->
          <!-- <button *ngSwitchCase="'company'" class="btn btn-success border-radius-10" (click)="onAddCompany()">Create New Company</button> -->
        </ng-container>
      </div>
    </div>

    <hr class="font-white" />

    <div class="search-area mb-3 ms-4 me-4 position-relative">
      <div [innerHtml]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="position-absolute mt-2 ms-2"></div>
      <input type="text" class="search-input ps-5" placeholder="Search {{ getSelectedTabLabel() }}"
        [(ngModel)]="searchTerm" (keyup)="applyFilter($event)" />
    </div>

    <!-- Dynamic Section -->
    <ng-container [ngSwitch]="selectedTab">
      <!-- Membership: Card View -->

      <ng-container *ngSwitchCase="'package'">
        <!-- <div *ngFor="let item of cardData; trackBy: trackByIndex" class="card ms-3 p-2 d-flex border-radius-10 mb-3" style="background-color: #111111 !important">
          <div class="row">
            <div class="col-4">
              <div class="d-flex align-items-center">
                <img src="public/gold-badge.png" alt="Gold Badge" />
                <div class="ms-2 mt-2">
                  <div class="fs-16 fw-bold font-white">{{ item.PackageName }}</div>
                  <p class="fs-14 fw-normal font-white">₹ {{ item.FinalAmount }}</p>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="d-flex align-items-center">
                <div class="ms-4 mt-2">
                  <div class="fs-12 fw-normal font-white">Start Date</div>
                  <div class="fs-14 fw-normal font-white">{{ item.StartTime | date : "dd/MM/yyyy" }}</div>
                </div>
                <div class="ms-4 mt-2">
                  <div class="fs-12 fw-normal font-white">End Date</div>
                  <div class="fs-14 fw-normal font-white">{{ item.EndTime | date : "dd/MM/yyyy" }}</div>
                </div>
                <div class="ms-4 mt-2">
                  <div class="fs-12 fw-normal font-white">Term</div>
                  <div class="fs-14 fw-normal font-white">{{ item.StartTime | date : "MMM yy" }} to {{ item.EndTime | date : "MMM yy" }}</div>
                </div>
              </div>
            </div>
            <div class="col-4 mt-2">
              <div class="d-flex justify-content-end align-items-center">
                <div class="ms-2 mt-2">
                  <button [ngClass]="item.IsActive ? 'plan-status-btn px-3' : 'absent-btn py-1 px-3'">
                    {{ item.IsActive ? "Active" : "Inactive" }}
                  </button>
                </div>
                <div class="action-container position-relative mt-2">
                  <button class="border-0 bg-none">
                    <div [innerHtml]="SVG_ICONS.ACTION_ICON() | sanitizer : 'html'"></div>
                  </button>
                  <div class="action-menu position-absolute bg-white z-2 border-radius-5">
                    <div
                      class="action-item p-2 cursor-pointer fs-16 fw-medium font-white"
                      (click)="onPlanDetails(item.PackageID)"
                      (keydown.enter)="onPlanDetails(item.PackageID)"
                      (keydown.space)="onPlanDetails(item.PackageID)"
                      tabindex="0"
                      role="button">
                      See Detail
                    </div>
                    <div
                      class="action-item p-2 cursor-pointer fs-16 fw-medium font-white"
                      (click)="onEditPlan(item.PackageID)"
                      (keydown.enter)="onEditPlan(item.PackageID)"
                      (keydown.space)="onEditPlan(item.PackageID)"
                      tabindex="0"
                      role="button">
                      Edit
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </ng-container>
      <!-- Region/Area/Menu: Table View -->
      <ng-container *ngSwitchDefault>
        <table class="w-100">
          <thead>
            <tr class="p-3 border-bottom">
              <!-- <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'user-access'">User Type ID</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'user-access'">User Type</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'user-access'">Action</th> -->

              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'company'">Company Name</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'company'">Address</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'company'">City</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'company'">State</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'company'">Country</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'company'">Contact Number</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'company'">PAN</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'company'">GSTIN</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'company'">CGST</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'company'">SGST</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'company'">Edit</th>

              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'region'">Region Name</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'region'">Edit</th>


              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'area'">Area Name</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'area'">Region Name</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'area'">Edit</th>

              <!-- <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'area'">City Name</th> -->
              <!--
                <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'city'">City Name</th>
                <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'city'">Region Name</th> -->

              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'center'">Center Name</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'center'">Address</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'center'">Contact Number</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'center'">Edit</th>

              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'menu'">Menu Name</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'menu'">Parent Menu</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'menu'">iOrder</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'menu'">Router Path</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'menu'">SVG</th>
              <!-- <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'package'">Status</th> -->
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'menu'">Edit</th>
              <th class="fs-14 fw-bold font-gray p-3" *ngIf="selectedTab === 'menu'">Add</th>
            </tr>
          </thead>

          <tbody>
            <tr class="border-bottom" *ngFor="let item of cardData; let i = index">
              <!-- <td class="p-3" *ngIf="selectedTab === 'user-access'">
                <span class="fw-bold fs-14 font-white">{{ item.UserTypeID }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'user-access'">
                <span class="fw-bold fs-14 font-white">{{ item.UserType }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'user-access'">
                <div
                  [innerHtml]="SVG_ICONS.EDIT_ICON() | sanitizer : 'html'"
                  (click)="onUserTypePermissionEdit(item.UserTypeID)"
                  (keydown.enter)="onUserTypePermissionEdit(item.UserTypeID)"
                  (keydown.space)="onUserTypePermissionEdit(item.UserTypeID)"
                  tabindex="0"
                  role="button"></div>
              </td> -->
              <td class="p-3" *ngIf="selectedTab === 'company'">
                <span class="fw-bold fs-14 font-white">{{ item.CompanyName }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'company'">
                <span class="fw-bold fs-14 font-white">{{ item.Address }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'company'">
                <span class="fw-bold fs-14 font-white">{{ item.City }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'company'">
                <span class="fw-bold fs-14 font-white">{{ item.State }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'company'">
                <span class="fw-bold fs-14 font-white">{{ item.Country }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'company'">
                <span class="fw-bold fs-14 font-white">{{ item.ContactNumber }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'company'">
                <span class="fw-bold fs-14 font-white">{{ item.PAN || "-" }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'company'">
                <span class="fw-bold fs-14 font-white">{{ item.GSTIN || "-" }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'company'">
                <span class="fw-bold fs-14 font-white">{{ item.CGST }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'company'">
                <span class="fw-bold fs-14 font-white">{{ item.SGST }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'company'">
                <div [innerHtml]="SVG_ICONS.EDIT() | sanitizer : 'html'" (click)="onEditCompany(item.CompanyID)"
                  (keydown.enter)="onEditCompany(item.CompanyID)" (keydown.space)="onEditCompany(item.CompanyID)"
                  tabindex="0" role="button"></div>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'region'">
                <span class="fw-bold fs-14 font-white">{{ item.RegionName }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'region'">
                <div [innerHtml]="SVG_ICONS.EDIT() | sanitizer : 'html'" (click)="onEditRegion(item.RegionID)"
                  (keydown.enter)="onEditRegion(item.RegionID)" (keydown.space)="onEditRegion(item.RegionID)"
                  tabindex="0" role="button"></div>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'area'">
                <span class="fw-bold fs-14 font-white">{{ item.AreaName }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'area'">
                <span class="fw-bold fs-14 font-white">{{ item["AreaRegion.RegionName"] || "-" }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'area'">
                <div [innerHtml]="SVG_ICONS.EDIT() | sanitizer : 'html'" (click)="onEditArea(item.AreaID)"
                  (keydown.enter)="onEditArea(item.AreaID)" (keydown.space)="onEditArea(item.AreaID)" tabindex="0"
                  role="button"></div>
              </td>

              <!-- <td class="p-3" *ngIf="selectedTab === 'area'">
                <span class="fw-bold fs-14 font-white">{{ item.AreaCity?.CityName || "-" }}</span>
              </td> -->
              <!-- <td class="p-3" *ngIf="selectedTab === 'city'">
                <span class="fw-bold fs-14 font-white">{{ item.CityName }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'city'">
                <span class="fw-bold fs-14 font-white">{{ item.CityRegion?.RegionName || "-" }}</span>
              </td> -->
              <td class="p-3" *ngIf="selectedTab === 'center'">
                <span class="fw-bold fs-14 font-white">{{ item.CenterName }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'center'">
                <span class="fw-bold fs-14 font-white">{{ item.Address }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'center'">
                <span class="fw-bold fs-14 font-white">{{ item.ContactNumber }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'center'">
                <span class="fw-bold fs-14 font-white">
                  <div [innerHtml]="SVG_ICONS.EDIT() | sanitizer : 'html'" (click)="onEditCenter(item.CenterID)"
                    (keydown.enter)="onEditCenter(item.CenterID)" (keydown.space)="onEditCenter(item.CenterID)"
                    tabindex="0" role="button"></div>
                </span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'menu'">
                <span class="fw-bold fs-14 font-white">{{ item.MenuName }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'menu'">
                <span class="fw-bold fs-14 font-white">{{ item.ParentMenuID }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'menu'">
                <span class="fw-bold fs-14 font-white">{{ item.iorder }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'menu'">
                <span class="fw-bold fs-14 font-white">{{ item.RouterPath }}</span>
              </td>
              <!-- <td class="p-3" *ngIf="selectedTab !== 'menu' && selectedTab !== 'user-access'">
                <span class="fw-bold fs-14 font-white">{{ item.IsActive ? "Active" : "Inactive" }}</span>
              </td> -->
              <td class="p-3" *ngIf="selectedTab === 'menu'">
                <span class="fw-bold fs-14 font-white">{{ item.svg_default ? "Yes" : "No" }}</span>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'menu'">
                <div [innerHtml]="SVG_ICONS.EDIT() | sanitizer : 'html'" (click)="onAction(item.MenuID)"
                  (keydown.enter)="onAction(item.MenuID)" (keydown.space)="onAction(item.MenuID)" tabindex="0"
                  role="button"></div>
              </td>
              <td class="p-3" *ngIf="selectedTab === 'menu'">
                <button class="border-0 bg-none">
                  <div [innerHtml]="SVG_ICONS.ADD_BUTTON() | sanitizer : 'html'" (click)="onCreateMenu()"
                    (keydown.enter)="onCreateMenu()" (keydown.space)="onCreateMenu()" tabindex="0" role="button"></div>
                </button>
              </td>
              <!-- <td class="p-3" *ngIf="selectedTab === 'User-Access'">
                <app-navigation-master></app-navigation-master>
              </td> -->
            </tr>
          </tbody>
        </table>
      </ng-container>
    </ng-container>

    @if(selectedTab === 'package'){
    <div class="d-flex gap-4 border-bottom border-secondary mt-3 mb-3">
      <div class="tab-item fs-14 fw-bold font-white pb-2 position-relative"
        [class.active]="selectedSubTab === 'Global Package'" (click)="onTabChange('Global Package')" tabindex="0"
        (keydown.enter)="onTabChange('Global Package')">
        <div class="px-3">Global Package</div>
        <div class="tab-underline position-absolute start-0 bottom-0 w-100"></div>
      </div>
      <div class="tab-item fs-14 fw-bold font-white pb-2 position-relative"
        [class.active]="selectedSubTab === 'Local Package(Area Wise)'" (click)="onTabChange('Local Package(Area Wise)')"
        tabindex="0" (keydown.enter)="onTabChange('Local Package(Area Wise)')">
        <div class="px-3">Local Package(Area Wise)</div>
        <div class="tab-underline position-absolute start-0 bottom-0 w-100"></div>
      </div>
    </div>
    @if(selectedSubTab === 'Global Package'){
    <div *ngFor="let item of globalPackageList; trackBy: trackByIndex"
      class="card ms-3 p-2 d-flex border-radius-10 mb-3" style="background-color: #111111 !important">
      <div class="row">
        <div class="col-4">
          <div class="d-flex align-items-center">
            <img src="public/gold-badge.png" alt="Gold Badge" />
            <div class="ms-2 mt-2">
              <div class="fs-16 fw-bold font-white">{{ item.PackageName }}</div>
              <p class="fs-14 fw-normal font-white">₹ {{ item.FinalAmount }}</p>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="d-flex align-items-center">
            <div class="ms-4 mt-2">
              <div class="fs-12 fw-normal font-white">Start Date</div>
              <div class="fs-14 fw-normal font-white">{{ item.StartTime | date : "dd/MM/yyyy" }}</div>
            </div>
            <div class="ms-4 mt-2">
              <div class="fs-12 fw-normal font-white">End Date</div>
              <div class="fs-14 fw-normal font-white">{{ item.EndTime | date : "dd/MM/yyyy" }}</div>
            </div>
            <div class="ms-4 mt-2">
              <div class="fs-12 fw-normal font-white">Term</div>
              <div class="fs-14 fw-normal font-white">{{ item.StartTime | date : "MMM yy" }} to {{ item.EndTime | date :
                "MMM yy" }}</div>
            </div>
          </div>
        </div>
        <div class="col-4 mt-2">
          <div class="d-flex justify-content-end align-items-center">
            <div class="ms-2 mt-2">
              <button [ngClass]="item.IsActive ? 'plan-status-btn px-3' : 'absent-btn py-1 px-3'">
                {{ item.IsActive ? "Active" : "Inactive" }}
              </button>
            </div>
            <div class="action-container position-relative mt-2">
              <button class="border-0 bg-none">
                <div [innerHtml]="SVG_ICONS.ACTION_ICON() | sanitizer : 'html'"></div>
              </button>
              <div class="action-menu position-absolute bg-white z-2 border-radius-5">
                <div class="action-item p-2 cursor-pointer fs-16 fw-medium font-white"
                  (click)="onPlanDetails(item.PackageID)" (keydown.enter)="onPlanDetails(item.PackageID)"
                  (keydown.space)="onPlanDetails(item.PackageID)" tabindex="0" role="button">
                  See Detail
                </div>
                <div class="action-item p-2 cursor-pointer fs-16 fw-medium font-white"
                  (click)="onEditPlan(item.PackageID)" (keydown.enter)="onEditPlan(item.PackageID)"
                  (keydown.space)="onEditPlan(item.PackageID)" tabindex="0" role="button">
                  Edit
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } @if(selectedSubTab === 'Local Package(Area Wise)'){
    <div *ngFor="let item of localPackageList; trackBy: trackByIndex" class="card ms-3 p-2 d-flex border-radius-10 mb-3"
      style="background-color: #111111 !important">
      <div class="row">
        <div class="col-4">
          <div class="d-flex align-items-center">
            <img src="public/gold-badge.png" alt="Gold Badge" />
            <div class="ms-2 mt-2">
              <div class="fs-16 fw-bold font-white">{{ item.PackageName }}</div>
              <p class="fs-14 fw-normal font-white">₹ {{ item.FinalAmount }}</p>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="d-flex align-items-center">
            <div class="ms-4 mt-2">
              <div class="fs-12 fw-normal font-white">Start Date</div>
              <div class="fs-14 fw-normal font-white">{{ item.StartTime | date : "dd/MM/yyyy" }}</div>
            </div>
            <div class="ms-4 mt-2">
              <div class="fs-12 fw-normal font-white">End Date</div>
              <div class="fs-14 fw-normal font-white">{{ item.EndTime | date : "dd/MM/yyyy" }}</div>
            </div>
            <div class="ms-4 mt-2">
              <div class="fs-12 fw-normal font-white">Term</div>
              <div class="fs-14 fw-normal font-white">{{ item.StartTime | date : "MMM yy" }} to {{ item.EndTime | date :
                "MMM yy" }}</div>
            </div>
          </div>
        </div>
        <div class="col-4 mt-2">
          <div class="d-flex justify-content-end align-items-center">
            <div class="ms-2 mt-2">
              <button [ngClass]="item.IsActive ? 'plan-status-btn px-3' : 'absent-btn py-1 px-3'">
                {{ item.IsActive ? "Active" : "Inactive" }}
              </button>
            </div>
            <div class="action-container position-relative mt-2">
              <button class="border-0 bg-none">
                <div [innerHtml]="SVG_ICONS.ACTION_ICON() | sanitizer : 'html'"></div>
              </button>
              <div class="action-menu position-absolute bg-white z-2 border-radius-5">
                <div class="action-item p-2 cursor-pointer fs-16 fw-medium font-white"
                  (click)="onPlanDetails(item.PackageID)" (keydown.enter)="onPlanDetails(item.PackageID)"
                  (keydown.space)="onPlanDetails(item.PackageID)" tabindex="0" role="button">
                  See Detail
                </div>
                <div class="action-item p-2 cursor-pointer fs-16 fw-medium font-white"
                  (click)="onEditPlan(item.PackageID)" (keydown.enter)="onEditPlan(item.PackageID)"
                  (keydown.space)="onEditPlan(item.PackageID)" tabindex="0" role="button">
                  Edit
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } }
  </div>
</div>